const googleCharts = {
  methods: {
    async loadGoogleCharts() {
      if (!window.google) {
        const script = document.createElement('script');
        script.src = 'https://www.gstatic.com/charts/loader.js';
        script.async = true;
        const loaded = new Promise((resolve) => {
          script.onload = () => {
            resolve(true);
          }
        })
        document.head.appendChild(script);
        await loaded;
      }
    }
  }
}

export default googleCharts;